import { CampaignPhishingSignEnum } from '@/client/campaigns';
import { FlexContainer } from '@/ui';
import { PhishingDifficultyIcon } from '@/utils/helpers/icons.helper';
import { t } from 'i18next';
import React from 'react';
import styled from 'styled-components';

const StyledFlexContainer = styled(FlexContainer)`
  padding: var(--medium-padding);
  width: 100%;
  padding-right: 0;
`;

const PhishingSignIcon = styled(FlexContainer)`
  color: var(--green-color);
  font-size: var(--xxsmall-font-size);
  line-height: var(--xxsmall-line-height);
  padding: var(--xxsmall-padding) var(--small-padding);
  border-radius: var(--grand-border-radius);
  background: #0e97971a;
  width: auto;
`;

const SimulationName = styled.span`
  color: var(--black-main);
  font-size: var(--medium-font-size);
  font-weight: 500;
  line-height: var(--medium-line-height);
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  max-width: 420px;
  text-align: left;
`;

const DifficultyContainer = styled.div`
  display: flex;
  align-items: center;
  gap: var(--xxsmall-padding);
`;

const DifficultyLabel = styled.span`
  color: var(--black-main);
  font-size: var(--xxsmall-font-size);
  margin-right: var(--xxsmall-padding);
`;

const FishIcon = styled.span<{ filled: boolean }>`
  svg path {
    fill: ${(props) => props.filled && 'var(--green-color)'};
  }
`;

type SimulationTemplateCardProps = {
  difficulty?: number;
  phishingSign?: CampaignPhishingSignEnum;
  name?: string;
  isGeneratedWithAI?: boolean;
};

export const SimulationTemplateCard: React.FC<SimulationTemplateCardProps> = ({
  difficulty,
  phishingSign,
  name,
  isGeneratedWithAI,
}) => {
  return (
    <StyledFlexContainer direction="column" align="flex-start" gap={3}>
      <PhishingSignIcon>
        {t(`campaign.template.${phishingSign}`)}
      </PhishingSignIcon>
      <SimulationName>{name}</SimulationName>
      {!isGeneratedWithAI && (
        <DifficultyContainer>
          <DifficultyLabel>
            {t('campaign.template.difficulty')}:
          </DifficultyLabel>
          {Array.from({ length: 5 }, (_, index) => (
            <FishIcon key={index} filled={index < (difficulty || 0)}>
              <PhishingDifficultyIcon />
            </FishIcon>
          ))}
        </DifficultyContainer>
      )}
    </StyledFlexContainer>
  );
};
